import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, SectionHeading } from "./Reveal";

export const FAQ_ITEMS = [
  {
    q: "In quali zone intervenite?",
    a: "Interveniamo a Roma e provincia. La disponibilità può variare in base alla zona e al tipo di intervento: contattaci indicando la tua zona per una verifica immediata.",
  },
  {
    q: "Intervenite anche di notte?",
    a: "FIX ROMA H24 è pensato per gestire richieste di pronto intervento anche nelle ore serali e notturne a Roma e provincia. Chiamaci per verificare la disponibilità del servizio nella tua zona.",
  },
  {
    q: "Vi occupate di cancelli automatici?",
    a: "Sì. Gestiamo cancelli automatici bloccati, problemi di apertura e chiusura, motori, fotocellule, telecomandi e automazioni.",
  },
  {
    q: "Vi occupate di serrande elettriche?",
    a: "Sì. Interveniamo su serrande elettriche, serrande bloccate, problemi di apertura e chiusura, motori e componenti.",
  },
  {
    q: "Vi occupate di serrature?",
    a: "Sì. Gestiamo problemi di serrature, serrature bloccate, problemi di accesso e sostituzioni quando tecnicamente e professionalmente appropriati.",
  },
  {
    q: "Fate anche apertura porte come un fabbro?",
    a: "Sì: gestiamo aperture di porte di casa e porte blindate, oltre a problemi di serrature e accessi, quando tecnicamente e professionalmente appropriati. Chiamaci descrivendo la situazione e la tua zona.",
  },
  {
    q: "Quanto costa un intervento?",
    a: "Il costo dipende dal tipo di problema e dall'intervento necessario. Contattaci descrivendo il tuo caso: valuteremo insieme la soluzione più adatta.",
  },
  {
    q: "Come posso richiedere assistenza?",
    a: "Premi il pulsante CHIAMA ORA al numero 06 8590 2421 oppure compila il modulo contatti indicando la zona e il problema. Verificheremo la disponibilità del servizio nella tua zona.",
  },
];

export const Faq = () => (
  <section
    id="faq"
    data-testid="faq-section"
    className="scroll-mt-24 py-20 sm:py-28"
  >
    <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
      <SectionHeading
        overline="Domande frequenti"
        title="Le risposte prima ancora della chiamata"
      />
      <Reveal delay={0.1} className="mt-10">
        <Accordion type="single" collapsible className="w-full">
          {FAQ_ITEMS.map((item, idx) => (
            <AccordionItem
              key={idx}
              value={`faq-${idx}`}
              data-testid={`faq-accordion-item-${idx + 1}`}
              className="border-white/[0.08]"
            >
              <AccordionTrigger
                data-testid={`faq-accordion-trigger-${idx + 1}`}
                className="text-left font-display text-base sm:text-lg font-semibold text-zinc-100 hover:text-amber-300 hover:no-underline"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm sm:text-base leading-relaxed text-zinc-400">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
